import { CustomField, TestSuite } from '../entity';
import { api } from '../../api/fetch';
export const saveTestSuite = async (testSuite: Partial<TestSuite>) => {
    return await api.post(`api/v1/test-suites`, testSuite);
}

export const saveTestSuiteFields = async (testSuiteId: number, fields: Partial<CustomField>[]) => { 
    return await api.post(`api/v1/test-suites/${testSuiteId}/settings`, fields);
}
